<div class="w-full">
  <h5 class="text-gray-900 mb-4 font-medium">{{ title }}</h5>

  <div
    *ngIf="!data || data.length === 0"
    class="w-full border rounded-lg p-4 cursor-default transition-all bg-gray-50/50 flex items-center justify-center"
    style="border-color: rgb(218, 227, 236); min-height: 80px"
  >
    <div class="flex items-center justify-center w-full">
      <p class="text-gray-500 m-0 text-center">
        {{
          languageKey.EMPTY_REGISTERS_OF
            | translateKey
            | formatTranslate: registerType
        }}
      </p>
    </div>
  </div>

  <div
    *ngIf="data.length > 0"
    class="ive-tree-container"
    [style.max-height]="maxHeigth"
  >
    <ng-container
      *ngTemplateOutlet="treeList; context: { $implicit: treeNodes, level: 0 }"
    ></ng-container>
  </div>

  <ng-template #treeList let-nodes let-level="level">
    <ul class="tree-ul" [class.root-list]="level === 0">
      <li *ngFor="let node of nodes" class="tree-li">
        <div class="tree-content-wrapper" [style.padding-left.px]="level * 20">
          <div class="expand-icon-container" (click)="toggleNode(node)">
            <i
              *ngIf="node.children && node.children.length > 0"
              class="pi"
              [class.pi-chevron-down]="node.expanded"
              [class.pi-chevron-right]="!node.expanded"
            >
            </i>
          </div>

          <div class="checkbox-container">
            <input
              type="checkbox"
              [(ngModel)]="node.selected"
              [indeterminate]="node.indeterminate"
              (change)="onCheckboxChange(node)"
            />
          </div>

          <div
            *ngIf="colorProperty"
            class="color-indicator"
            [style.background-color]="getColor(node)"
          ></div>

          <span class="tree-label">{{ node.data[labelProperty] }}</span>
        </div>

        <div *ngIf="node.expanded && node.children && node.children.length > 0">
          <ng-container
            *ngTemplateOutlet="
              treeList;
              context: { $implicit: node.children, level: level + 1 }
            "
          ></ng-container>
        </div>
      </li>
    </ul>
  </ng-template>
</div>
